import image from '@/assets/images/manufacturers/ista.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'ISTA',
  label: 'ista',
  image,
}));
